export default async function fetchResource(url, body) {
    const response = await fetch(url, {
        method: "POST",
        headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
        },
        body: body
    });
    if (response.status === 200) {
        const data = await response.text();
        return Promise.resolve(data);
    }
    else {
        return Promise.reject("Something went wrong");
    }
}